// plan-18 S01: question hash seeding — re-uses djb2 + Mulberry32 from plan-13

import { fromString, mulberry32 } from '../../core/seed'
import { normalize } from './normalize'

const BASE32_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'

export function qHash(question: string): string {
  const n = normalize(question)
  const num = fromString(n)
  let hash = ''
  let bits = num >>> 0
  for (let i = 0; i < 6; i++) {
    hash += BASE32_CHARS[bits & 0x1F]
    bits = bits >>> 5
  }
  return hash
}

export function qShortHash(question: string): string {
  return qHash(question).slice(0, 4)
}

export { fromString as djb2, mulberry32, normalize }
